// extracted by mini-css-extract-plugin
export default {"menuBlock":"GD-z","title":"HD-z","nav":"ID-z","flexCell":"JD-z","facetLink":"KD-z"};